import React from "react";
import { ConvenioDetailsPage } from "./convenioDetails.page";
import { ConvenioDetailsProvider } from "./context/convenio-details-context";

export function ConvenioDetailsFactory() {
    return (
        <ConvenioDetailsProvider>
            <ConvenioDetailsPage />
        </ConvenioDetailsProvider>
    );
}
